import { render } from "./CustomerDetailPage.vue?vue&type=template&id=a72b498c&scoped=true"
import script from "./CustomerDetailPage.vue?vue&type=script&lang=js"
export * from "./CustomerDetailPage.vue?vue&type=script&lang=js"

import "./CustomerDetailPage.vue?vue&type=style&index=0&id=a72b498c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72b498c"]])

export default __exports__